import type { TMedia } from '~constants/media';
import { BlurUpImage } from '~shared/ui/atoms/BlurUpImage';
import { FadeInImage } from '~shared/ui/atoms/FadeInImage';

import { CarouselList, GridCarouselItem } from './styles';

type TCarouselProps = {
	items?: TMedia[][];
	fallbacks: string[];
};

export const GridCarousel = ({
	items = [],
	fallbacks = [],
}: TCarouselProps) => {
	const images = items.length ? items : fallbacks;

	return (
		<CarouselList>
			{images.map((_, index) => {
				const showLowQualityPreview = index < 2;
				const props = {
					media: items[index],
					fallback: fallbacks[index],
					width: 300,
					height: 400,
					quality: 85,
					fetchPriority: index === 0 ? 'high' : 'low',
					alt: '',
				} as const;

				return (
					<GridCarouselItem key={index} tabIndex={0}>
						{showLowQualityPreview ? (
							<BlurUpImage {...props} />
						) : (
							<FadeInImage {...props} />
						)}
					</GridCarouselItem>
				);
			})}
		</CarouselList>
	);
};
